import { getPreloadedLoomMeetingRecorderEligibility } from '@confluence/loom-utils/entry-points/getPreloadedLoomMeetingRecorderEligibility.ts';
import { fg } from '@confluence/feature-gating';

export type UseMeetingRecorderEligibilityResult = {
	/** null when the cohort is excluded or the View Page preload has no eligibility data. */
	isAvailable: boolean | null;
};

/** Reads Loom settings from the View Page preload after the cohort feature gate admits the user. */
export function useMeetingRecorderEligibility({
	isHighTouch,
	isLowTouch,
}: {
	isHighTouch: boolean | null;
	isLowTouch: boolean | null;
}): UseMeetingRecorderEligibilityResult {
	const isHighTouchEnabled = isHighTouch === true && fg('twcg-2202-loom-meeting-nudge-ht-gate');
	const isLowTouchEnabled = isLowTouch === true && fg('twcg-2202-loom-meeting-nudge-lt-gate');

	const loomData =
		isHighTouchEnabled || isLowTouchEnabled
			? getPreloadedLoomMeetingRecorderEligibility()
			: undefined;

	return {
		isAvailable:
			loomData === undefined
				? null
				: loomData.hasTeamworkCollection === true &&
					loomData.meetingRecordingsAvailable === true &&
					loomData.connectedCalendars?.length === 0,
	};
}
